import { render, staticRenderFns } from "./Acompanhamentos.vue?vue&type=template&id=3ebfca1d&scoped=true"
import script from "./Acompanhamentos.vue?vue&type=script&lang=js"
export * from "./Acompanhamentos.vue?vue&type=script&lang=js"
import style0 from "./Acompanhamentos.vue?vue&type=style&index=0&id=3ebfca1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebfca1d",
  null
  
)

export default component.exports